<cap-rubrik [isClosable]="false" [isOpen]="true" id="rubrik-grundstueck-grundlasten">
  <ng-container title>
    <h2 class="mb-0">{{ "grundstueck.rubrik.Grundlasten" | translate }}</h2>
  </ng-container>

  <cap-standardrecht-table [hasRight]="grundstueckEntry?.permissions?.grundlasten && ersterfassungUebergeben" [listLoader]="loader">
  </cap-standardrecht-table>
</cap-rubrik>
